module.exports = __webpack_public_path__ + "static/media/img_new02@2x_en.a1c3b467.png";